var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labeled-switch"},[_c('span',{class:{ checked: !_vm.checked }},[_vm._v(_vm._s(_vm.$t("no")))]),_c('b-form-checkbox',{attrs:{"checked":_vm.checked,"switch":""},on:{"input":function($event){return _vm.$emit('input', $event)}}}),_c('span',{class:{ checked: _vm.checked }},[_vm._v(_vm._s(_vm.$t("yes")))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }